var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkHubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 238,
    viewBox: "0 0 242 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 142.17C52 156.53 40.3594 168.17 26 168.17C11.6406 168.17 0 156.53 0 142.17C0 127.811 11.6406 116.17 26 116.17C40.3594 116.17 52 127.811 52 142.17Z",
    fill: "url(#paint0_linear_25_48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 115.5C181.5 145.047 157.547 169 128 169C98.4528 169 74.5 145.047 74.5 115.5C74.5 85.9528 98.4528 62 128 62C157.547 62 181.5 85.9528 181.5 115.5Z",
    fill: "url(#paint1_linear_25_48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 35.5C238.5 55.1061 222.606 71 203 71C183.394 71 167.5 55.1061 167.5 35.5C167.5 15.8939 183.394 0 203 0C222.606 0 238.5 15.8939 238.5 35.5Z",
    fill: "url(#paint2_linear_25_48)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.5 211C210.5 225.912 198.412 238 183.5 238C168.588 238 156.5 225.912 156.5 211C156.5 196.088 168.588 184 183.5 184C198.412 184 210.5 196.088 210.5 211Z",
    fill: "url(#paint3_linear_25_48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127 2C137.139 2 146.968 3.32479 156.326 5.80762C156.44 7.69098 156.5 9.58885 156.5 11.5C156.5 16.5488 156.096 21.5057 155.321 26.3428C146.378 23.5217 136.864 22 127 22C82.288 22 44.7625 53.2389 34.9824 95.2666C34.3287 98.0758 33.8002 100.935 33.4004 103.837C26.7188 102.117 20.3175 99.7258 14.2754 96.7432C14.6333 94.7218 15.0412 92.7177 15.5029 90.7334C27.3294 39.9122 72.7205 2 127 2Z",
    fill: "url(#paint4_linear_25_48)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.675 79.6982C239.453 91.1118 241.5 103.317 241.5 116C241.5 133.182 237.742 149.511 230.995 164.179C226.896 173.091 221.691 181.389 215.559 188.896C210.316 184.532 205.786 179.364 202.162 173.588C206.325 168.105 209.913 162.154 212.825 155.821C218.39 143.723 221.5 130.241 221.5 116C221.5 106.753 220.184 97.8173 217.735 89.3691C223.108 85.2722 229.151 81.9873 235.675 79.6982Z",
    fill: "url(#paint5_linear_25_48)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6738 177.146C72.0162 197.852 97.9928 211 127 211C132.191 211 137.286 210.578 142.251 209.768C144.892 215.823 146.612 222.36 147.236 229.208C140.669 230.384 133.906 231 127 231C91.044 231 58.9846 214.362 38 188.352C42.904 183.814 48.5232 180.019 54.6738 177.146Z",
    fill: "url(#paint6_linear_25_48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_48",
    x1: 140.5,
    y1: 227,
    x2: 92.6182,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A82465"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHubLogo);
export default __webpack_public_path__ + "static/media/LinkHub-Logo.a8840ead47cfdf5db4e1a1bdedee808e.svg";
export { ForwardRef as ReactComponent };